import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
import { environment } from "../../environments/environment"
@Injectable({
  providedIn: 'root'
})
export class ReportingConfigService {

  constructor(private http : HttpClient) { }

  saveEntity(result:any,userUID:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/crm/entity/save/"+userUID,result,{headers : headers,observe:"response"});
   }

   listEntities(userUID:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/crm/entity/list/"+userUID,{headers : headers,observe:"response"});
   }

   saveTags(tagName:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/reporting/tags/AIR/customtag/"+tagName, null);
   }
   UpdateTags(tagName:any,request:any,userId:any) {
   
    let headers = new HttpHeaders();
    if(userId){
    return this.http.post(environment.API_URL+"/api/reporting/tags/AIR/"+userId+"/customtag/"+tagName, request,{observe:"response"});
  }else{
    return this.http.post(environment.API_URL+"/api/reporting/tags/AIR/customtag/"+tagName, request,{observe:"response"});

  }
   }

   tagList(userId:any) {
    let headers = new HttpHeaders();
    if(userId){

    return this.http.get(environment.API_URL+"/api/reporting/tags/AIR/customtag/"+userId,{headers : headers,observe:"response"});}
    else{
      return this.http.get(environment.API_URL+"/api/reporting/tags/AIR/customtag",{headers : headers,observe:"response"});}

    
   }
   tagPAX(userId:any) {
   
    let headers = new HttpHeaders();
    return this.http.get(environment.API_URL+"/api/reporting/tags/AIR/customtag/tag/PAX/"+userId,{headers : headers,observe:"response"});
   }
}
